import { Component, Input, OnInit } from '@angular/core';
import { EventMonitorInfo } from '../../../../models/event-monitor-info';


@Component({
  selector: 'app-monitor-event',
  templateUrl: './monitor-event.component.html',
  styleUrls: ['./monitor-event.component.scss']
})
export class MonitorEventComponent implements OnInit {

  @Input() event: EventMonitorInfo;
  constructor() { }

  ngOnInit() {
  }

  getSoldRemotelyPercentageOfCapacity(): string {

    if (this.event.soldQuantity > 0 && this.event.soldRemotely > 0) {
      return ((this.event.soldRemotely / this.event.venueCapacity) * 100) + '%';
    }
    return '0%';
  }
  getSoldPercentageOfCapacity(): string {
    if (this.event.soldQuantity > 0 && this.event.venueCapacity > 0) {
      return ((this.event.soldLocaly / this.event.venueCapacity) * 100) + '%';
    }
    return '0%';
  }
}
